<template lang="">
    <div>
		<router-view></router-view>
	</div>
</template>
<script>
import { useRegStore } from "@/store";
export default {
	
};
</script>
<style scoped>
@import url(~@/assets/css/form.css);
</style>